import { FC } from 'react';

import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import { FirstCategoryLevel } from 'src/api/types';
import { getIconProps, getIconSrc } from './NavigationList';

type NavigationListItem = FirstCategoryLevel | null;

interface Props {
  listClassName: string;
  items: NavigationListItem[];
  selectedItem: NavigationListItem;
  setSelectedItem: (item: NavigationListItem) => void;
}

const NavigationList: FC<Props> = ({
  listClassName,
  items,
  setSelectedItem
}) => {
  const clickHandler = (item) => {
    setSelectedItem(item);
  };
  return (
    <ul className={listClassName}>
      {items?.map((item) => {
        return (
          <li key={item.translitName}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <div
              onClick={() => clickHandler(item)}
              className={cn(
                'flex relative border-b border-gray200 last:border-none items-center h-[48px]'
              )}
            >
              <div
                className={cn(
                  'flex items-center justify-between compendium-w-full-105 compendium-min-h-10 h-auto top-0 cursor-pointer'
                )}
              >
                <div className="mx-6 w-7">
                  <NextImage
                    alt="icon"
                    src={getIconSrc(item.translitName)}
                    layout="fixed"
                    height={getIconProps(item.translitName).height}
                    width={getIconProps(item.translitName).width}
                  />
                </div>
                <p className="w-full text-black mr-6">{item.name}</p>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default NavigationList;
